import { observer } from "mobx-react-lite"

import { Dialog } from "@/components/Dialog/Dialog.tsx"
import { Vertical } from "@/components/Flex.ts"
import { ProjectSecretsEditor } from "@/components/ProjectSecretsEditor/ProjectSecretsEditor.tsx"
import { Spinner } from "@/components/Spinner/Spinner.tsx"
import { useCurrentProject, useProjectPermissions } from "@/routes/projects/projectHooks.ts"
import { ellipsize } from "@/styles/textStyles.ts"

import type { ProjectSecretsViewModel } from "@/routes/projects/secrets/ProjectSecretsViewModel.ts"

export const ProjectSecretsDialog = observer(({ open, onOpenChange, ...props }: {
  open: boolean,
  onOpenChange: (open: boolean) => void,
  readOnly: boolean,
  model: ProjectSecretsViewModel
}) => {
  const project = useCurrentProject()
  const projectPermissions = useProjectPermissions(project.key)
  const canModifySecretsProject = projectPermissions.canView // Secrets management is available to members

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      trigger={null}
      title="Secrets"
    >
      <Vertical>
        {props.model.isLoading.get()
          ? <Spinner text={ellipsize("Loading")} />
          : (
            <ProjectSecretsEditor
              secrets={props.model.secrets.get()}
              onAddSecret={props.model.addSecret}
              onDeleteSecret={props.model.deleteSecret}
              onValueChange={props.model.updateSecretValue}
              canEditProject={canModifySecretsProject}
              disabled={props.readOnly}
            />
          )}
      </Vertical>
    </Dialog>
  )
})
